import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaYoutube
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="zoho-footer">
      <div className="zoho-footer-container">

        {/* TOP GRID */}
        <div className="zoho-footer-grid">

          {/* COMPANY INFO */}
          <div className="zoho-footer-col">
            <h3 className="zoho-footer-logo">
              <span className="zoho-logo-highlight">M</span>PEOPLES
            </h3>

            <p className="zoho-footer-tagline">
              Powered by the People, for the People.
            </p>

            <p className="zoho-footer-desc">
              MPeoples Business Solutions Pvt Ltd offering IT services,
              education, marketing, and digital solutions.
            </p>

            <div className="zoho-footer-socials">
              <a href="https://facebook.com" aria-label="Facebook"><FaFacebook /></a>
              <a href="https://linkedin.com" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="https://instagram.com" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://youtube.com" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="zoho-footer-col">
            <h4 className="zoho-footer-title">Quick Links</h4>
            <ul className="zoho-footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* SERVICES */}
          <div className="zoho-footer-col">
            <h4 className="zoho-footer-title">Our Services</h4>
            <ul className="zoho-footer-links">
              <li><Link to="/services/website-development">Web Development</Link></li>
              <li><Link to="/services/edu-tech">Edu Tech</Link></li>
              <li><Link to="/services/hr-consultancy">HR Consultancy</Link></li>
              <li><Link to="/services/digital-marketing">Digital Marketing</Link></li>
              <li><Link to="/services/website-development">Training & Courses</Link></li>
              <li><Link to="/services/graphic-designing">Graphic Design</Link></li>
              <li><Link to="/services/local-advertisement">Local Advertisement</Link></li>
            </ul>
          </div>

          {/* CONTACT INFO */}
          <div className="zoho-footer-col">
            <h4 className="zoho-footer-title">Contact Info</h4>

            <ul className="zoho-footer-contact">
              <li>Salem, Tamil Nadu, India</li>
              <li>+91 98765 43210</li>
              <li>info@mpeoples.in</li>
              <li>Mon – Fri: 9:00 AM – 6:00 PM</li>
            </ul>

            <div className="zoho-footer-websites">
              <span>Website URLs</span>
              <p>
                www.mpeoples.in<br />
                www.mpeoplesdemo.com
              </p>
            </div>
          </div>

        </div>

        {/* DIVIDER */}
        <div className="zoho-footer-divider"></div>

        {/* BOTTOM BAR */}
        <div className="zoho-footer-bottom">
          <p>
            © {currentYear} MPEOPLES BUSINESS SOLUTION PVT LTD.
            All rights reserved.
          </p>

          <div className="zoho-footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
